import React from 'react'
import {Table, TableCaption, TableContainer, Tbody, Td, Thead, Tr, Th, Tfoot} from '@chakra-ui/react'
import CategoryRowModal from '../CategoryRowModal/CategoryRowModal'
import CategoryRowDelete from './CategoryRowDelete'

const CategoryRowsTable = (props) => {
    const {categoryRows, countingId, fetchCategoryRows} = props

    const categoryByRow = (row) => categoryRows.find(c => c.row_from <= row && c.row_to >= row)
    return (
        <TableContainer>
            <Table variant='striped'>
                <TableCaption>List of the rows categories</TableCaption>
                <Thead>
                    <Tr>
                        <Th> Group </Th>
                        <Th> Name </Th>
                        <Th> From </Th>
                        <Th> To </Th>
                        <Th> Count </Th>
                        <Th> Completed </Th>
                        <Th>% percent</Th>
                        <Th> Actions </Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {categoryRows.map(cat => (
                        <Tr key={cat._id}>
                            <Td> {cat.group} </Td>
                            <Td> {cat.name} </Td>
                            <Td> {cat.row_from} </Td>
                            <Td> {cat.row_to} </Td>
                            <Td> {cat.row_to-cat.row_from+1} </Td>
                            <Td> {cat.rowsCount} </Td>
                            <Td> {(cat.row_to - cat.row_from + 1) ? (cat.rowsCount/(cat.row_to-cat.row_from+1)*100).toFixed(2) : 0}%</Td>
                            <Td>
                                <CategoryRowModal
                                    fetchCategoryRows={fetchCategoryRows}
                                    id={cat._id}
                                    group={cat.group}
                                    name={cat.name}
                                    rowFrom={cat.row_from}
                                    rowTo={cat.row_to}
                                    countingId={countingId}
                                    mode={'update'}
                                    categoriesWithRowsInARange={props.categoriesWithRowsInARange}
                                
                                />
                                <CategoryRowDelete
                                    id={cat._id}
                                    fetchCategoryRows={fetchCategoryRows}
                                    countingId={countingId}
                                />
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
                <Tfoot>
                    <Tr fontWeight='bold'>
                      <Td>TOTAL</Td>
                      <Td></Td>
                      <Td>{/*categoryRows.reduce((sum, cat) => sum + (cat.row_from + 1), 0)*/}</Td>
                      <Td>{/*categoryRows.reduce((sum, cat) => sum + (cat.row_to + 1), 0)*/}</Td>
                      <Td>{categoryRows.reduce((sum, cat) => sum + ((cat.row_to-cat.row_from+1) + 1), 0)}</Td>
                      <Td>{categoryRows.reduce((sum, cat) => sum + (cat.rowsCount + 1), 0)}</Td>
                      <Td>{categoryRows.reduce((sum, cat) => sum + ((cat.row_to-cat.row_from+1) + 1), 0) ? 
                          ((categoryRows.reduce((sum, cat) => sum + (cat.rowsCount + 1), 0)) /
                          (categoryRows.reduce((sum, cat) => sum + ((cat.row_to-cat.row_from+1) + 1), 0))*100).toFixed(2) : 0}% </Td>
                    </Tr>
                </Tfoot>   
            </Table>
        </TableContainer>
    )
}

export default CategoryRowsTable